import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Collapse,
  CardTitle,
  ModalFooter,
  Alert,
} from 'reactstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

// Custom Components
import { CustomLoading, Loading, LoadingIcon } from '../../components/Loading';
import { PetTreatmentTable } from '../../components/PetTreatmentTable';
import ClientDataComponent from '../../components/ClientDataComponent';
import PetDataComponent from '../../components/PetDataComponent';
import PrintCertificateComponent from '../../components/PrintCertificateComponent';
import { GetFormattedDate } from '../../components/FormatDate';

// Forms
import CreatePetForm from '../../forms/Pet';
import UpdateClientForm from '../../forms/Client';
import CreateTreatmentForm from '../../forms/Treatment';

// Services
import { getSingleClientData, editClientData, deleteClient } from '../../services/Clients/actions';
import {
  getSinglePetTreatments, addSingleTreatment, sendSmsWithTwilio, sendEmail,
} from '../../services/Treatments/actions';
import { getPetData, createPet } from '../../services/Pets/actions';

class ClientDetails extends Component {
  state = {
    editClient: false,
    selectedOption: null,
    clientId: '',
    addReportModal: false,
    addPetModal: false,
    isPrintingCertificate: false,
    sendMessage: false,
    toggleSendEmail: false,
    treatmentData: {},
    deleteClientModal: false,
    vaccinationData: {},
  };

  constructor(props) {
    super(props);
    this.toggleEditClient = this.toggleEditClient.bind(this);
    this.toggleAddTreatmentModal = this.toggleAddTreatmentModal.bind(this);
    this.toggleAddPetModal = this.toggleAddPetModal.bind(this);
    this.openTreatment = this.openTreatment.bind(this);
    this.editPet = this.editPet.bind(this);
    this.togglePrintCertificate = this.togglePrintCertificate.bind(this);
    this.toggleSendMessage = this.toggleSendMessage.bind(this);
    this.toggleSendEmail = this.toggleSendEmail.bind(this);
    this.toggleDeleteClientModal = this.toggleDeleteClientModal.bind(this);
  }

  componentDidMount() {
    const {
      match: {
        params: {
          id,
        },
      },
    } = this.props;
    this.props.getSingleClientData(id);
    this.setState({
      clientId: this.props.match.params.id,
    });
  }

  handleAddPet = (values) => {
    const {
      Clients: {
        clientData,
      },
      match: {
        params: {
          id,
        },
      },
    } = this.props;
    const {
      clientId,
    } = this.state;

    const tempValues = values;
    tempValues.owner = clientId;
    tempValues.ownerName = clientData.name;

    this.props.createPet(tempValues, () => {
      this.props.getSingleClientData(id);
      this.toggleAddPetModal();
    });
  }

  // Form submissions
  handleEditClient = (values) => {
    const {
      match: {
        params: {
          id,
        },
      },
    } = this.props;
    const {
      clientId,
    } = this.state;

    this.props.editClientData(clientId, values, () => {
      this.props.getSingleClientData(id);
      this.toggleEditClient();
    });
  }

  handleTreatmentSubmit = (values) => {
    const {
      selectedOption,
    } = this.state;
    const asd = values;
    // reports re sent seperately as its a
    const tempReports = values.reports;
    delete asd.reports;
    this.props.addSingleTreatment(tempReports, selectedOption.value, asd, () => {
      this.props.getSinglePetTreatments(selectedOption.value);
      // close modal after submission
      this.toggleAddTreatmentModal();
    });
  }

  handleChange = (selectedOption) => {
    this.setState(
      { selectedOption },
      () => {
        // selected option is not null
        this.props.getPetData(selectedOption.value);
        this.props.getSinglePetTreatments(selectedOption.value);
      },
    );
  };

  togglePrintCertificate(test) {
    this.setState((prevState) => ({
      isPrintingCertificate: !prevState.isPrintingCertificate,
      treatmentData: test,
    }));
  }

  toggleEditClient() {
    this.setState((prevState) => ({
      editClient: !prevState.editClient,
    }));
  }

  // Other functions

  editPet(id) {
    const {
      history,
    } = this.props;
    history.push(`/pet/${id}`);
  }

  openTreatment(id) {
    const {
      selectedOption,
    } = this.state;
    this.props.history.push(`/treatment/${selectedOption.value}/${id}`);
  }

  // Modal Togglers
  toggleDeleteClientModal() {
    this.setState((prevState) => ({
      deleteClientModal: !prevState.deleteClientModal,
    }));
  }

  toggleAddPetModal() {
    this.setState((prevState) => ({
      addPetModal: !prevState.addPetModal,
    }));
  }

  toggleAddTreatmentModal() {
    this.setState((prevState) => ({
      addReportModal: !prevState.addReportModal,
    }));
  }

  toggleSendMessage(treatmentId, vaccData) {
    if (vaccData != null) {
      this.setState({
        treatmentId,
        vaccinationData: vaccData,
      });
    }
    this.setState((prevState) => ({
      sendMessage: !prevState.sendMessage,
    }));
  }

  toggleSendEmail(treatmentId, vaccData) {
    if (vaccData != null) {
      this.setState({
        treatmentId,
        vaccinationData: vaccData,
      });
    }
    this.setState((prevState) => ({
      toggleSendEmail: !prevState.toggleSendEmail,
    }));
  }

  render() {
    const {
      Clients,
      Treatments,
      Pets,
      history,
    } = this.props;

    const { clientData } = Clients;
    const { isLoading } = Clients;
    const treatmentList = Treatments.petTreatmentList;
    const { precautionList } = Treatments;
    const treatmentIsLoading = Treatments.isLoading;
    const treatmentIsRunning = Treatments.isRunning;
    const petIsLoading = Pets.isLoading;
    const { petData } = Pets;

    const {
      editClient,
      selectedOption,
      isPrintingCertificate,
      clientId,
      treatmentData,
      deleteClientModal,
      addReportModal,
      addPetModal,
      sendMessage,
      toggleSendEmail,
      treatmentId,
      vaccinationData,
    } = this.state;

    if (isLoading) {
      return (
        <Loading />
      );
    }

    // Initial Dates initialization
    const initialTreatment = {
      date: new Date(),
    };
    const initialDob = {
      dob: new Date(),
    };

    if (editClient) {
      return (
        <div>
          <div className="justify-content-end">
            <Button color="danger" onClick={this.toggleDeleteClientModal} className="mt-2 mr-2 mb-2">
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>
          <UpdateClientForm
            onSubmit={this.handleEditClient}
            isLoading={isLoading}
            initialValues={clientData}
            submitLabel="Update User Data"
            handleCancel={this.toggleEditClient}
            showCancel
          />

          <Modal
            isOpen={deleteClientModal}
            toggle={this.toggleDeleteClientModal}
          >
            <ModalHeader toggle={this.toggleDeleteClientModal}>
              Delete Client?
            </ModalHeader>
            <ModalBody>
              <div>
                Delete this client?
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={() => {
                  this.props.deleteClient(clientId, () => {
                    history.push('/home');
                  });
                }}
              >
                Yes
              </Button>
              <Button color="secondary" onClick={() => { this.toggleDeleteClientModal(); }}>No</Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }

    if (isPrintingCertificate) {
      return (
        <PrintCertificateComponent
          clientData={clientData}
          petData={petData}
          treatmentData={treatmentData}
          togglePrintCertificate={this.togglePrintCertificate}
        />
      );
    }

    return (
      <div>
        <Container>
          <Row className="pt-3">
            <Col className="pt-3" xs={{ size: 12 }} md={{ size: 6 }}>
              <ClientDataComponent
                toggleAddPetModal={this.toggleAddPetModal}
                clientData={clientData}
                editPet={this.editPet}
                toggleEditClient={this.toggleEditClient}
              />
            </Col>
            <Col className="pt-3" xs={{ size: 12 }} md={{ size: 6 }}>
              <Row>
                <Col sm="12">
                  <Select
                    value={selectedOption}
                    onChange={this.handleChange}
                    options={clientData.owned}
                    placeholder="Select Pet"
                  />
                </Col>
              </Row>
              <Row className="pt-3" noGutters>
                <Col sm="12">
                  {selectedOption && (
                  <PetDataComponent
                    petData={petData}
                  />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <>
            {selectedOption && (
            <Row className="pt-3" noGutters>
              <Col sm="12">
                <Button className="w-100" color="primary" onClick={this.toggleAddTreatmentModal}>
                  Add Treatment
                </Button>
              </Col>
            </Row>
            )}
            <Collapse isOpen={addReportModal}>
              <Card>
                <CardBody>
                  <CreateTreatmentForm
                    onSubmit={this.handleTreatmentSubmit}
                    isLoading={treatmentIsLoading}
                    initialValues={initialTreatment}
                    isNew
                    submitLabel="Create"
                  />
                </CardBody>
              </Card>
            </Collapse>
            {(selectedOption && precautionList.length > 0) && (
              <Row className="pt-3" noGutters>
                <Col xs={{ size: 12 }} md={{ size: 12 }}>
                  <Card body inverse color="danger">
                    <CardTitle>
                      <div className="d-flex justify-content-center">
                        <strong>
                          <FontAwesomeIcon icon={faExclamationCircle} />
                          Precaution
                        </strong>
                      </div>
                    </CardTitle>
                    {precautionList.length > 0 && precautionList.map((precaution) => (
                      // Redirect to home of clicked user with id
                      <li
                        key={precaution.id}
                      >
                        <Link
                          style={{ textDecoration: 'none', color: 'white', cursor: 'pointer' }}
                          to={`/treatment/${selectedOption.value}/${precaution.id}`}
                        >
                          {GetFormattedDate(precaution.date.seconds * 1000)}
                          {' '}
                          :
                          {' '}
                          {precaution.precaution}
                        </Link>
                      </li>
                    ))}
                  </Card>
                </Col>
              </Row>
            )}

            <Row noGutters className="pt-3">
              <Col sm="12">
                {selectedOption ? (
                  <div>
                    {treatmentIsLoading ? (
                      <div className="d-flex justify-content-center">
                        <CustomLoading />
                      </div>
                    ) : (
                      <div>
                        {treatmentList.length > 0 ? (
                          <PetTreatmentTable
                            petTreatmentList={treatmentList}
                            openTreatment={this.openTreatment}
                            toggleSendMessage={this.toggleSendMessage}
                            toggleSendEmail={this.toggleSendEmail}
                            togglePrintCertificate={this.togglePrintCertificate}
                          />
                        ) : (
                          <div className="d-flex justify-content-center mb-5">
                            <Alert color="primary">
                              No treatments present yet
                            </Alert>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    {selectedOption && (
                    <div className="d-flex justify-content-center">
                      Pet not selected
                    </div>
                    )}
                  </div>
                )}
              </Col>
            </Row>
          </>
        </Container>
        <Modal
          isOpen={addPetModal}
          toggle={this.toggleAddPetModal}
        >
          <ModalHeader toggle={this.toggleAddPetModal}>
            Add Pet
          </ModalHeader>
          <ModalBody>
            <CreatePetForm
              onSubmit={this.handleAddPet}
              isLoading={petIsLoading}
              initialValues={initialDob}
              isNew
            />
          </ModalBody>
        </Modal>

        <Modal
          isOpen={sendMessage}
          toggle={this.toggleSendMessage}
        >
          <ModalHeader toggle={this.toggleSendMessage}>
            Send SMS Confirmation
          </ModalHeader>
          <ModalBody>
            {(clientData.phoneM1 || clientData.phoneM2) ? (
              <>
                <div>
                  Vaccinations required are:
                </div>
                <div>
                  {vaccinationData.length > 0 && vaccinationData.map((row) => (
                    <div key={row.value}>
                      {row.label}
                    </div>
                  ))}
                </div>
                Send SMS to
                <div>
                  -
                  {clientData.phoneM1}
                </div>
                <div>
                  -
                  {clientData.phoneM2}
                </div>
              </>
            ) : (
              <div>
                No mobile number entered for client
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            {treatmentIsRunning && (<LoadingIcon />)}
            {(clientData.phoneM1 || clientData.phoneM2) && (
            <Button
              color="primary"
              onClick={() => {
                this.props.sendSmsWithTwilio(
                  selectedOption.value,
                  treatmentId,
                  clientData.phoneM1,
                  clientData.phoneM2,
                  vaccinationData,
                  petData.name,
                  () => {
                    this.toggleSendMessage(null);
                  },
                );
              }}
            >
              Yes
            </Button>
            )}
            <Button
              color="secondary"
              onClick={() => { this.toggleSendMessage(null); }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={toggleSendEmail}
          toggle={this.toggleSendEmail}
        >
          <ModalHeader toggle={this.toggleSendEmail}>
            Send Email Confirmation
          </ModalHeader>
          <ModalBody>
            {clientData.email1 || clientData.email2 ? (
              <>
                <div />
                <div>
                  Vaccinations required are:
                </div>
                <div>
                  {vaccinationData.length > 0 && vaccinationData.map((row) => (
                    <div key={row.value}>
                      {row.label}
                    </div>
                  ))}
                </div>
                Send Email to
                <div>
                  -
                  {clientData.email1 && (clientData.email1)}
                </div>
                <div>
                  -
                  {clientData.email2 && (clientData.email2)}
                </div>
              </>
            ) : (
              <div>
                Client does not have email.
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            {treatmentIsRunning && (<LoadingIcon />)}
            {(clientData.email1 || clientData.email2) && (
            <Button
              color="primary"
              disabled={treatmentIsRunning}
              onClick={() => {
                this.props.sendEmail(selectedOption.value, treatmentId, clientData.email1 || '', clientData.email2 || '', vaccinationData, petData.name, () => {
                  this.toggleSendEmail(null);
                });
              }}
            >
              Yes
            </Button>
            )}
            <Button
              color="secondary"
              disabled={treatmentIsRunning}
              onClick={() => { this.toggleSendEmail(null); }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Clients: state.Clients,
  Treatments: state.Treatments,
  Pets: state.Pets,
});

const mapDispatchToProps = {
  getSingleClientData,
  deleteClient,
  editClientData,
  getSinglePetTreatments,
  addSingleTreatment,
  createPet,
  getPetData,
  sendSmsWithTwilio,
  sendEmail,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientDetails);
